import React from 'react';
import { projects } from '../data/mock';
import { ExternalLink } from 'lucide-react';

const Projects = () => {
  return (
    <div>
      <h1 className="text-2xl font-serif mb-8">Projects</h1>

      {/* Divider */}
      <div className="border-b border-[#1f1f23] mb-8"></div>

      {/* Projects List */}
      <div className="space-y-6">
        {projects.map((project) => (
          <div
            key={project.id}
            className="pb-6 border-b border-[#1f1f23]"
          >
            <div className="flex items-start justify-between">
              <div>
                <h3 className="font-medium text-white mb-1">
                  {project.url && project.url !== '#' ? (
                    <a 
                      href={project.url} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="hover:text-[#c5c5d0] transition-colors inline-flex items-center gap-1"
                    >
                      {project.name}
                      <ExternalLink size={14} />
                    </a>
                  ) : (
                    project.name
                  )}
                </h3>
                <p className="text-[#8f8fa3] text-sm mb-3">{project.description}</p>
                <div className="flex flex-wrap gap-2">
                  {project.tech.map((tech) => (
                    <span
                      key={tech}
                      className="text-xs text-[#c5c5d0] bg-[#151518] px-2 py-0.5 rounded"
                    >
                      {tech}
                    </span>
                  ))}
                </div>
              </div>
              <span className="text-sm text-[#7a7a86]">{project.year}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Projects;
